import React from 'react';
import { Box, Flex, Stack } from '@mantine/core';
import styles from './SuitabilityBody.module.css';

type FooterAlign = 'left' | 'center' | 'right';

type SuitabilityBodyProps = {
  children: React.ReactNode;
  footer?: React.ReactNode;
  footerAlign?: FooterAlign;
};

export function SuitabilityBody({
  children,
  footer,
  footerAlign = 'center',
}: SuitabilityBodyProps) {
  const justify =
    footerAlign === 'center' ? 'center' : footerAlign === 'right' ? 'flex-end' : 'flex-start';

  return (
    <Stack gap={0} h={'100%'} pos={'relative'}>
      <Box px="md" pb={footer ? 96 : undefined} flex={1} mih={0} className={styles.scrollbar}>
        {children}
      </Box>

      {footer && (
        <Box
          px="sm"
          py="sm"
          pos="absolute"
          bottom={16}
          left="50%"
          w="fit-content"
          maw="calc(100% - 32px)"
          style={theme => ({
            transform: 'translateX(-50%)',
            zIndex: 10,

            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            backdropFilter: 'blur(10px)',

            borderRadius: theme.radius.xl,
            boxShadow: '0 10px 30px theme.black',
          })}
        >
          <Flex justify={justify} gap="sm" wrap="nowrap">
            {footer}
          </Flex>
        </Box>
      )}
    </Stack>
  );
}
